import script from "./file.vue?vue&type=script&lang=ts"
export * from "./file.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__